import { BankVerificationSource } from "Infrastructure/Api/Api";
import type { CodeListItem } from "Models/ICodeListDto";
import { Resources, useResource } from "Translations/Resources";
import { typedObjectEntries } from "Utils/ObjectUtils";
import { useMemo } from "react";

type ListItem = CodeListItem<BankVerificationSource>;
type Result = ListItem[];

export const useBankVerificationSourceList = () => {
  const { t } = useResource();

  return useMemo<Result>(
    () =>
      typedObjectEntries(BankVerificationSource).map<ListItem>(
        ([key, value]) => ({
          code: value,
          name: t(Resources.Form.BankVerificationSource[key]),
        }),
      ),
    [t],
  );
};
